<template>
    <div class="www pt-4 pb-2 select-none">
        <label
            for="i-textAlign"
            class="block text-sm font-medium text-gray-700"
        >
            {{ t('templateTextAlign') }}
        </label>
        <select
            id="i-textAlign"
            v-model="members.textAlign"
            name="i-textAlign"
            class="mt-1 block w-full rounded-md border border-gray-300 bg-white px-2 py-1 shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden sm:text-sm"
            :disabled="!stateRepository.states.textAlign"
        >
            <option
                v-for="r in textAligns"
                :key="r.value"
                :value="r.value"
            >
                {{ r.title }}
            </option>
        </select>
    </div>
</template>

<script setup>
    import { t } from '../composables/i18n';

    defineExpose({
        name: 'TextAlign',
    });

    const props = defineProps({
        members: {
            type: Object,
            default: () => {
                return {};
            },
        },
        stateRepository: {
            type: Object,
            required: true,
        },
    });

    const stateRepository = props.stateRepository;

    const textAligns = [
        {
            value: 'left',
            title: t('templateTextAlignLeft'),
        },
        {
            value: 'center',
            title: t('templateTextAlignCenter'),
        },
        {
            value: 'right',
            title: t('templateTextAlignRight'),
        },
        {
            value: 'justify',
            title: t('templateTextAlignJustify'),
        },
    ];

    const members = props.members;
</script>
